module.exports = __webpack_public_path__ + "img/product_103.8b5d8c0.webp";